import React from 'react';

import { NavLink } from 'react-router-dom';

export default function Link({ url, icon }) {
  return (
    <li>
      <NavLink
        to={url}
        className={({ isActive }) => {
          return isActive
            ? 'flex items-center p-2 rounded-lg transition duration-75 text-gray-900 dark:text-white bg-gray-100 dark:bg-gray-700'
            : 'flex items-center p-2 text-gray-400 rounded-lg transition duration-75 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700';
        }}
      >
        {icon}
      </NavLink>
    </li>
  );
}
